import { render, staticRenderFns } from "./Menudata.vue?vue&type=template&id=1a7095aa&scoped=true"
import script from "./Menudata.vue?vue&type=script&lang=js"
export * from "./Menudata.vue?vue&type=script&lang=js"
import style0 from "./Menudata.vue?vue&type=style&index=0&id=1a7095aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7095aa",
  null
  
)

export default component.exports